import SidePage from '@/shared/SidePage'
import { IUnit } from '@/pages/Parameters/parameters.types.ts'
import useUnit from '@/pages/MDM/hooks/useUnit.ts'
import SeparateLine from '@/shared/Forms/SeparateLine'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import mdmUtils from '@/pages/MDM/mdm.utils.ts'
import useNestedArrayChangeCallbacks from '@/shared/hooks/useNestedArrayChangeCallbacks.ts'
import Button from '@/shared/Buttons/Button'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import mdmApi from '@/pages/MDM/mdm.api.ts'
import mdmEvents from '@/pages/MDM/events/mdm.events.ts'
import { IMDMUnitField } from '@/pages/MDM/mdm.types.ts'
import { useEffect } from 'react'
import TextArea from '@/shared/Inputs/TextArea'
import MDMValueInput from '@/pages/MDM/components/MDMValueInput'

interface IProps {
  open: boolean
  onClose: () => void
  unitId: IUnit['id']
}

const CreateUnitInstanceSidePage = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const unit = useUnit(props.unitId)
  const [dto, setDto, handleChange] = useStateWithChange(mdmUtils.generateCreateUnitInstanceDTO(unit))

  const { handleElementUpdate: handleValueUpdate } = useNestedArrayChangeCallbacks({
    sourceObjectSetter: setDto,
    nestedArrayKey: 'values',
  })

  useEffect(() => {
    setDto(mdmUtils.generateCreateUnitInstanceDTO(unit))
  }, [unit])

  const handleCreate = () => {
    wait(mdmApi.createUnitInstance(dto), (resp) => {
      if (resp.status === 'success') {
        mdmEvents.unitInstanceCreated(resp.body)
        props.onClose()
      }
    })
  }

  const renderFieldInput = (field: IMDMUnitField, index: number) => {
    if (!dto.values[index]) return null

    const value = dto.values[index]
    return (
      <MDMValueInput
        value={field.type === 'ENUM' ? value.enumValueId?.toString() : value.value}
        schema={field as any}
        name="value"
        onChange={(val, name) => handleValueUpdate(index, val, name)}
        onUnitValueChange={() => {}}
        onEnumValueChange={(val) => handleValueUpdate(index, val, 'enumValueId')}
        placeHolder="Введите значение"
      />
    )
  }

  return (
    <SidePage onClose={props.onClose} open={props.open} style={{ paddingBottom: 0 }}>
      <div className="flex-lines gap16 height100">
        <h4 className="text-heading-4">Создание экземпляра</h4>
        <SeparateLine />
        <FormField label="Родительский агрегат">
          <TextInput value={unit.name} name="unit_name" onChange={() => {}} disabled={true} />
        </FormField>
        <FormField label="Наименование" required={true}>
          <TextInput value={dto.name} name="name" onChange={handleChange} placeHolder="Введите наименование" />
        </FormField>
        <FormField label="Комменатрий" required={false}>
          <TextArea value={dto.comment} name="comment" onChange={handleChange} placeHolder="Введите комментарий" />
        </FormField>
        <SeparateLine />
        <h5 className="text-heading-5">Значения</h5>
        {unit.fields.map((f, index) => (
          <FormField label={f.name} key={f.id} required={true}>
            {renderFieldInput(f, index)}
          </FormField>
        ))}
        <div style={{ marginTop: 'auto' }}>
          <SeparateLine />
        </div>
        <div className="inline-flex-gap gap8" style={{ paddingBottom: '24px' }}>
          <Button
            size="default"
            type="primary"
            disabled={!unit.name}
            loading={loading}
            onClick={handleCreate}
            text="Создать"
          />
          <Button size="default" type="default" onClick={props.onClose} disabled={loading} text="Отмена" />
        </div>
      </div>
    </SidePage>
  )
}

export default (props: IProps) => {
  if (!props.unitId) return null

  return <CreateUnitInstanceSidePage {...props} />
}
